// ─────────────────────────────────────────────────────────────────────────────────────────────────────────────
// L'HANDOFF v2 (ARCHITETTURA §8.1, ADR-005): Quick apre Dim con ?iss=<mondo>&code=<monouso>&state=<nonce>[&returnUrl=…].
// Il codice si riscatta UNA volta dal server; `state` torna a Quick tale e quale; il ritorno è solo verso i prefissi
// registrati (lo verifica il server al riscatto, qui si costruisce soltanto l'URL).
// ─────────────────────────────────────────────────────────────────────────────────────────────────────────────

export interface Handoff {
  iss: string;
  code: string;
  state: string | null;
  returnUrl: string | null;
}

export function parseHandoff(search: string): Handoff | null {
  const q = new URLSearchParams(search);
  const iss = q.get('iss');
  const code = q.get('code');
  if (!iss || !code || !/^[a-z0-9]{2,16}$/.test(iss)) return null;
  return { iss, code, state: q.get('state'), returnUrl: q.get('returnUrl') };
}

/** Toglie il codice dalla barra degli indirizzi appena letto: un ricarico non deve riprovarlo (è monouso) né lasciarlo nella cronologia. */
export function scrubHandoffFromUrl(): void {
  if (location.search.length > 0) history.replaceState(null, '', location.pathname);
}

export type Esito = 'OK' | 'KO';

/**
 * `returnUrl` è l'indirizzo di Quick AL MOMENTO del handoff: dopo la prima misura contiene già i parametri del ritorno precedente. Si cancellano prima di scrivere
 * quelli nuovi, altrimenti un ritorno senza misura (KO) si porterebbe dietro l'id della misura di prima. `state` è nostro per lo stesso motivo: Quick non ha parametri con questi nomi.
 */
export function buildReturnUrl(returnUrl: string, state: string | null, esito: Esito, measurementId: string | null): string {
  const url = new URL(returnUrl);
  for (const stale of ['dimEsito', 'dimMisuraId', 'state']) url.searchParams.delete(stale);
  url.searchParams.set('dimEsito', esito);
  if (measurementId) url.searchParams.set('dimMisuraId', measurementId);
  if (state) url.searchParams.set('state', state);
  return url.toString();
}
